/** CSS custom properties from tokens.css — keep order in sync with --geo-brand-* tokens. */
export const GEO_BRAND_COLOR_VARS = [
  'var(--geo-brand-1)',
  'var(--geo-brand-2)',
  'var(--geo-brand-3)',
  'var(--geo-brand-4)',
  'var(--geo-brand-5)',
  'var(--geo-brand-6)',
  'var(--geo-brand-7)',
];

export function getGeoBrandColor(index = 0) {
  const i = Number(index);
  if (!Number.isFinite(i) || i < 0) return GEO_BRAND_COLOR_VARS[0];
  return GEO_BRAND_COLOR_VARS[i % GEO_BRAND_COLOR_VARS.length];
}

/** Stable brand → color map from company ranking order (rank or array index). */
export function buildGeoBrandColorMap(brands = []) {
  const map = new Map();
  brands.forEach((row, index) => {
    const colorIndex = row?.rank != null ? row.rank - 1 : index;
    map.set(row.brand, getGeoBrandColor(colorIndex));
  });
  return map;
}

export function getGeoBrandColorForBrand(brand, colorMap, fallbackIndex = 0) {
  if (colorMap?.has(brand)) return colorMap.get(brand);
  return getGeoBrandColor(fallbackIndex);
}
